import { render, staticRenderFns } from "./safeCenter.vue?vue&type=template&id=951c334a&"
import script from "./safeCenter.vue?vue&type=script&lang=js&"
export * from "./safeCenter.vue?vue&type=script&lang=js&"
import style0 from "./safeCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports